import { Component, OnInit, ViewChild } from '@angular/core';
import { TreelistComponent } from '../../../core/shared/treelist/treelist.component';
import { StructureUserEventsService } from '../structure-user-events.service';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'app-structure-user-roles',
  templateUrl: './structure-user-roles.component.html',
  styleUrls: ['./structure-user-roles.component.css']
})
export class StructureUserRolesComponent implements OnInit, HasPermissions {
  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  @ViewChild(TreelistComponent) grid: TreelistComponent;

  public apiPath = 'api/user/roles';

  constructor(
    private eventsService: StructureUserEventsService,
    private permissionService: PermissionsService
  ) { }

  ngOnInit() {
    this.setPermissions("Role");
   }

  private onElementSelected(id: any) {
    this.eventsService.announceSelectClick(id);
  }

}
